var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSpanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_667_659)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4708 2.73515C9.67473 2.71641 8.86802 2.99261 8.26363 3.59701C7.39744 4.4632 7.14709 5.68171 7.56299 6.72147C7.67442 7.00003 7.60911 7.31819 7.39696 7.53034L2.86363 12.0637C2.55652 12.3708 2.55652 12.8292 2.86363 13.1363C3.17074 13.4435 3.6292 13.4435 3.9363 13.1363L8.46964 8.60301C8.67337 8.39928 8.97579 8.33027 9.24773 8.42545C10.3216 8.80131 11.5551 8.59087 12.4776 7.72831C13.1233 7.07833 13.4299 6.24108 13.3864 5.45246L11.723 7.07089C11.429 7.35695 10.9597 7.35373 10.6696 7.06367L8.9363 5.33034C8.79565 5.18969 8.71663 4.99892 8.71663 4.80001C8.71663 4.6011 8.79565 4.41033 8.9363 4.26968L10.4708 2.73515ZM12.0776 1.5439C10.5127 0.946639 8.55511 1.1842 7.20297 2.53635C6.05963 3.67968 5.60899 5.29605 6.00989 6.7961L1.80297 11.003C0.910077 11.8959 0.910077 13.3041 1.80297 14.197C2.69586 15.0899 4.10407 15.0899 4.99696 14.197L9.21665 9.97732C10.6889 10.3272 12.2999 9.95554 13.514 8.81283C13.5195 8.80763 13.5249 8.80236 13.5303 8.79701C14.8633 7.464 15.2991 5.4546 14.4708 3.79793C14.3437 3.54384 14.084 3.38334 13.8 3.38334H13.667C13.4716 3.38334 13.2836 3.45957 13.1436 3.5958L11.2072 5.4799L10.5273 4.80001L12.397 2.93034C12.4879 2.83941 12.6666 2.62501 12.6666 2.30834C12.6666 2.12145 12.5982 1.88885 12.398 1.7137C12.2927 1.62158 12.1799 1.57074 12.0776 1.5439Z",
    className: "icon-fill"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_667_659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpanner);
export default __webpack_public_path__ + "static/media/icon-spanner.90c7200647f09ef31cede8d8c49b2dc0.svg";
export { ForwardRef as ReactComponent };